import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import { isEmpty } from 'lodash';
import './EmptyContactDocuments.scss';

const EmptyContactDocuments = ({ documents, styles, isDrawer }) => (
  isEmpty(documents) && (
    <div className={`empty-documents col-xs-12 ${isDrawer ? 'mb-24' : ''}`}>
      <div className="empty-documents__notification">
        <p className="empty-documents__notification-text">No documents uploaded yet</p>
      </div>
      {
        !isDrawer && (
          <div className="empty-documents__helper">
            <Icon icon="IconArrow" style={styles.iconArrow} />
            <p className="empty-documents__helper-text">UPLOAD HERE</p>
          </div>
        )
      }
    </div>
  )
);

EmptyContactDocuments.propTypes = {
  documents: PropTypes.array.isRequired,
  styles: PropTypes.shape({
    iconArrow: PropTypes.object,
  }),
  isDrawer: PropTypes.bool,
};

EmptyContactDocuments.defaultProps = {
  styles: {},
  isDrawer: false,
};

export default EmptyContactDocuments;
